import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { UndefinedVariable } from '@portal-core/reports/models/undefined-variables.model';

@CollectionStateSelectors({
  stateType: ProjectReportsUndefinedVariablesState
})
@State<ProjectReportsUndefinedVariablesState>({
  name: ProjectReportsUndefinedVariablesState.source
})
@Service({ autoProvided: false })
export class ProjectReportsUndefinedVariablesState extends CollectionStateBase {
  static override source = 'ProjectReportsUndefinedVariables';
  getSource(): string {
    return ProjectReportsUndefinedVariablesState.source;
  }
}

@Service()
export class ProjectReportsUndefinedVariablesDataService extends CollectionDataServiceBase<UndefinedVariable> {
  protected readonly stateType = ProjectReportsUndefinedVariablesState;
}
